import axios from "axios";

const fetchApi = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

export default fetchApi;
